import { AccessToken, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class UserService {
  DoGetUserInfo() {
    const headers = {
      Authorization: `Bearer ${AccessToken()}`,
    };
    const params = {};
    return service.peakRealTimeAPIForUser.get("/api/User/GetUserInfoByUserId", { params, headers }).then((res) => {
      return res;
    });
  }
  DoGetSelectedMerchant(merchantId: number) {
    const headers = SetHeaderService().headers;
    const params = { merchantId: merchantId };
    return service.peakRealTimeAPIForUser.get("/api/Merchant/GetSelectedMerchant", { params, headers }).then((res) => {
      return res;
    });
  }
}

export default new UserService();
